import { joinArrayToString } from "../utils/string";
import {
  getDropdownListStops,
  isHighValueParcel,
  isSmallsToteParcel,
} from "../features/routeDetail/model";
import { getServiceWindow } from "./stop";
import { findLeadParcel } from "./parcel";

const ADDRESS_SEPARATOR = ", ";
const LABEL_SEPARATOR = " - ";

export const formatStopAddress = (stop) =>
  joinArrayToString([
    stop.stopAddress?.contactName,
    stop.stopAddress?.address1,
  ]);

export const formatRouteStopLabel = (routeStop) => {
  const address = formatStopAddress(routeStop);

  return joinArrayToString(
    [routeStop.displayNumber, routeStop.stopAddress?.postcode, address],
    LABEL_SEPARATOR
  );
};

export const createStopOptions = (stops) =>
  stops.map((stop) => ({
    value: stop.stopNumber,
    label: formatRouteStopLabel(stop),
  }));

export const getMergeSplitTableData = (stops) =>
  stops.map((stop) => ({
    displayNumber: stop.displayNumber,
    sequenceNumber: stop.sequenceNumber,
    address: formatStopAddress(stop),
    postcode: stop.stopAddress?.postcode,
    totalParcels: stop.totalParcels,
    totalCadParcels: stop.totalCadParcels,
    eta: stop.eta || "",
    exception: stop.exception || "",
    window: getServiceWindow(stop),
    stopTime: stop.stopTime,
    highValue: isHighValueParcel(stop),
    smallsToteParcel: isSmallsToteParcel(stop),
  }));

export const prepareTableData = (parcel) =>
  Object.values(parcel).map(
    ({
      priority,
      parcelNumber,
      cadScanned,
      loaded,
      address,
      window,
      service,
      type,
      parcelCode,
      parcelStatus,
      highValue,
      smallsToteParcel,
    }) => ({
      priority,
      parcelNumber,
      cadScanned,
      loaded,
      address,
      window,
      service,
      type,
      parcelCode,
      parcelStatus,
      highValue,
      smallsToteParcel,
    })
  );

export const getDropdownListSplitStop = (
  selectedParcels,
  availableStops,
  matchPostcodes
) => {
  const leadParcel = findLeadParcel(Object.values(selectedParcels));
  const [postcode] = leadParcel.address.split(ADDRESS_SEPARATOR).slice(-1);

  return getDropdownListStops(
    { stopAddress: { postcode } },
    availableStops,
    matchPostcodes
  );
};
